import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import {ComposedChart, YAxis, XAxis, Tooltip, CartesianGrid, Line, Bar, ResponsiveContainer} from 'recharts';
import followersDataOfCoin from 'selectors/followersDataOfCoin';
import { getMinMax, formatUnix, colors, getDot, getBarSize, allPlatforms } from 'helpers/helpers'
import LoadingBar from '../../../components/loadingBar'
import getTimeInterval from 'selectors/timeInterval'
import {fetchCoinData} from 'actions/listeners/counts';
import getPlatformsOfCoin from 'selectors/platformsOfCoin'
// import getSelectedCoinObj from 'selectors/selectedCoinObj'
import './styles.css'

class Chart extends PureComponent {

  componentDidMount = () => {
    this.props.fetchCoinData()
  }

  componentDidUpdate = (prev) => {
    const { coin, trackedDays, untilDate } = this.props
    const coinChagned        = prev.coin !== coin
    const trackedDaysChanged = prev.trackedDays !== trackedDays
    const untilDateChanged   = prev.untilDate !== untilDate

    if(coinChagned || trackedDaysChanged || untilDateChanged){
      this.props.fetchCoinData()
    }
  }

  fTick = (n) => (Math.round(n / 100) / 10) + ' K'

  render(){

    const {
      priceData,
      counts,
      trackedDays,
      startTime,
      untilTime,
      countsDataStatus,  
      priceDataDataStatus,
      currentCountDataStatus,
      redditMentionsDataStatus,
      redditMentionsSubDataStatus,
      mobileVersion,
      platformsOfCoin,
      hiddenPlatforms,
      highlightedPlatform
    } = this.props

    // chartVisible
    const cv = (plat) => (platformsOfCoin[plat] || plat === 'price') && !hiddenPlatforms.includes(plat)
    // axisPresent
    const ap = (plat) =>  platformsOfCoin[plat] && !hiddenPlatforms.includes(plat)
    // axisVisible
    const av = (plat) => {
      if(mobileVersion) return false
      return platformsOfCoin[plat] && plat === highlightedPlatform
    }


    const dataInRange = counts.filter(d => d.time > startTime)

    const mergedData = ( dataInRange || [] ).concat(priceData)

    // const twitterDomain   = getMinMax(trackedDays, dataInRange, 'twitter')
    const telegramDomain  = getMinMax(trackedDays, dataInRange, 'telegram')
    const redditDomain    = getMinMax(trackedDays, dataInRange, 'reddit')
    const discordDomain   = getMinMax(trackedDays, dataInRange, 'discord')

    // const pl = platformsOfCoin
    const dot = (platform) => getDot(trackedDays, colors[platform], mobileVersion)
    const barSize = getBarSize(trackedDays, mobileVersion)

    if(
      countsDataStatus !== 'LOADED' || 
      currentCountDataStatus !== 'LOADED' ||
      priceDataDataStatus === 'REQUESTED' || // TODO: change this to NOT LOADED
      redditMentionsDataStatus === 'REQUESTED' ||
      redditMentionsSubDataStatus === 'REQUESTED'
    ){
      return <LoadingBar />
    }

    return(
      <fb className="chart-wrapper-main">
        <ResponsiveContainer height='100%' width='100%'>
        <ComposedChart data={mergedData} margin={{top: 5, right: 30, left: 20, bottom: 5}} barGap={2}>
          <XAxis dataKey="time"        type="number" domain={[ startTime, untilTime ]} tickFormatter={(time) => moment.unix(time).format('MMM DD.')} tickCount={11} tick={{fontSize: 12}}/>
          <YAxis hide={mobileVersion} dataKey="price"       yAxisId="price"       type="number" stroke={colors.price} tick={{fontSize: 12}} />
          <YAxis dataKey="volume"      yAxisId="volume"      type="number" domain={[0, dataMax => (dataMax * 6)]} hide={true} tick={{fontSize: 12}}/>
          { ap('reddit') &&      <YAxis hide={!av('reddit')}      dataKey="reddit"      yAxisId="reddit"      type="number" orientation="right" tickFormatter={this.fTick} stroke={colors.reddit} domain={redditDomain} tick={{fontSize: 12}} /> }
          { ap('reddit_a') &&    <YAxis hide={!av('reddit_a')}    dataKey="reddit_a"    yAxisId="reddit_a"    type="number" orientation="right" stroke={colors['reddit_a'] } domain={[0, 'auto']} tick={{fontSize: 12}} /> }
          { ap('reddit_m') &&    <YAxis hide={!av('reddit_m')}    dataKey="reddit_m"    yAxisId="reddit_m"    type="number" orientation="right" stroke={colors['reddit_m'] } domain={[0, dataMax => (dataMax * 2)]} tick={{fontSize: 12}} /> }
          { ap('reddit_ms') &&   <YAxis hide={!av('reddit_ms')}   dataKey="reddit_ms"   yAxisId="reddit_ms"   type="number" orientation="right" stroke={colors['reddit_ms'] } domain={[0, dataMax => (dataMax * 4)]} tick={{fontSize: 12}} /> }
          { ap('telegram') &&    <YAxis hide={!av('telegram')}    dataKey="telegram"    yAxisId="telegram"    type="number" orientation="right" tickFormatter={this.fTick} stroke={colors.telegram }       domain={telegramDomain} tick={{fontSize: 12}} /> }
          { ap('telegram_a') &&  <YAxis hide={!av('telegram_a')}  dataKey="telegram_a"  yAxisId="telegram_a"  type="number" orientation="right" tickFormatter={this.fTick} stroke={colors['telegram_a'] }  domain={[0, 'auto']} tick={{fontSize: 12}} /> }
          { ap('discord') &&     <YAxis hide={!av('discord')}     dataKey="discord"     yAxisId="discord"     type="number" orientation="right" tickFormatter={this.fTick} stroke={colors.discord }        domain={discordDomain} tick={{fontSize: 12}} /> }
          { ap('discord_a') &&   <YAxis hide={!av('discord_a')}   dataKey="discord_a"   yAxisId="discord_a"   type="number" orientation="right" stroke={colors['discord_a'] } domain={[0, 'auto']} tick={{fontSize: 12}} /> }
          { ap('bitcointalk') && <YAxis hide={!av('bitcointalk')} dataKey="bitcointalk" yAxisId="bitcointalk" type="number" orientation="right" stroke={colors.bitcointalk } domain={[0, dataMax => (dataMax * 2)]} tick={{fontSize: 12}} tickFormatter={(n) => Math.round(n)} /> }
          <CartesianGrid strokeDasharray="5 5" stroke="#444"/>
          <Tooltip labelFormatter={(unix) => formatUnix(unix)} />
          { !!cv('reddit') &&      <Line type="monotone" dot={dot('reddit')} isAnimationActive={false} yAxisId="reddit"           dataKey="reddit"      stroke={colors.reddit} strokeWidth={1}/> }
          { !!cv('reddit_a') &&    <Line type="monotone" dot={dot('reddit_a')} isAnimationActive={false} yAxisId="reddit_a"       dataKey="reddit_a"    stroke={colors['reddit_a'] } strokeWidth={1}/> }
          { !!cv('reddit_m') &&    <Line type="monotone" dot={dot('reddit_m')} isAnimationActive={false} yAxisId="reddit_m"       dataKey="reddit_m"    stroke={colors['reddit_m'] } strokeWidth={1} strokeDasharray="3 1"/> }
          { !!cv('reddit_ms') &&   <Line type="monotone" dot={dot('reddit_ms')} isAnimationActive={false} yAxisId="reddit_ms"     dataKey="reddit_ms"   stroke={colors['reddit_ms'] } strokeWidth={1} strokeDasharray="3 1"/> }
          { !!cv('discord') &&     <Line type="monotone" dot={dot('discord')} isAnimationActive={false} yAxisId="discord"         dataKey="discord"     stroke={colors['discord'] } strokeWidth={1}/> }
          { !!cv('discord_a') &&   <Line type="monotone" dot={dot('discord_a')} isAnimationActive={false} yAxisId="discord_a"     dataKey="discord_a"   stroke={colors['discord_a'] } strokeWidth={1}/> }
          { !!cv('telegram') &&    <Line type="monotone" dot={dot('telegram')} isAnimationActive={false} yAxisId="telegram"       dataKey="telegram"    stroke={colors.telegram } strokeWidth={1}/> }
          { !!cv('telegram_a') &&  <Line type="monotone" dot={dot('telegram_a')} isAnimationActive={false} yAxisId="telegram_a"   dataKey="telegram_a"  stroke={colors['telegram_a'] } strokeWidth={1}/> }
          { !!cv('bitcointalk') && <Line type="monotone" dot={dot('bitcointalk')} isAnimationActive={false} yAxisId="bitcointalk" dataKey="bitcointalk" stroke={colors.bitcointalk } strokeWidth={1}/> }
          { !!cv('price') && <Line type="monotone" dot={dot('price')} isAnimationActive={false} yAxisId="price"       dataKey="price"       stroke={colors.price} strokeWidth={1} /> }
          { <Bar dataKey="volume" barSize={barSize} fill="grey" fillOpacity={0.2} yAxisId='volume' isAnimationActive={false} /> }
        </ComposedChart>
      </ResponsiveContainer>
      </fb>
    )
  }
}

const actionsToProps = {
  fetchCoinData
}

const mapStateToProps = (state: Store) => ({
  coin: state.ui.selectedCoin,
  counts: followersDataOfCoin(state),
  priceData: state.priceData,

  countsDataStatus: state.countsDataStatus,
  currentCountDataStatus: state.currentCountDataStatus,
  priceDataDataStatus: state.priceDataDataStatus,
  redditMentionsDataStatus: state.redditMentionsDataStatus,
  redditMentionsSubDataStatus: state.redditMentionsSubDataStatus,

  trackedDays: state.ui.trackedDays,
  untilDate: state.ui.untilDate,
  startTime: getTimeInterval(state).start,
  untilTime: getTimeInterval(state).end,
  platformsOfCoin: getPlatformsOfCoin(state),
  hiddenPlatforms: state.ui.hiddenPlatforms,
  highlightedPlatform: state.ui.highlightedPlatform
  // coin: selectedCoinObj(state)
})

export default connect(mapStateToProps, actionsToProps)(Chart)



// WEBPACK FOOTER //
// ./src/containers/components/chart/index.js